import styled from "styled-components";

export default styled.header`
  position: relative;
  padding: ${({ theme }) => `${theme.spacing(3)}px 0`};
  background: ${({ theme }) => theme.palette.background.paper};
`;
